import { apiFetch } from '@ami/react/core';
import { SharedDocumentFilter } from './sharedDocumentFilter';
import SharedDocumentForQuoteFilter from './sharedDocumentForqQuoteFilter';

const _baseEndPoint = 'sharedDocuments';

export class SharedDocument {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.currentVersion = item.currentVersion;
      this.fileKey = item.fileKey;
      this.fileName = item.fileName;

      if (item.productGroupIds) {
        this.productGroupIds = item.productGroupIds;
      }
      if (item.productOptionIds) {
        this.productOptionIds = item.productOptionIds;
      }
      if (item.productIds) {
        this.productIds = item.productIds;
      }
      if (item.couplerStyleIds) {
        this.couplerStyleIds = item.couplerStyleIds;
      }

      if (item.productGroups) {
        this.productGroupIds = item.productGroups.map((x) => x.id);
        this.productGroups = item.productGroups;
      }
      if (item.productOptions) {
        this.productOptionIds = item.productOptions.map((x) => x.id);
        this.productOptions = item.productOptions;
      }
      if (item.products) {
        this.productIds = item.products.map((x) => x.id);
        this.products = item.products;
      }
      if (item.couplerStyles) {
        this.couplerStyleIds = item.couplerStyles.map((x) => x.id);
        this.couplerStyles = item.couplerStyles;
      }

      return;
    }
    this.id = null;
    this.name = '';
    this.productGroupIds = [];
    this.productOptionIds = [];
    this.productIds = [];
    this.currentVersion = undefined;
    this.fileKey = undefined;
    this.fileName = '';
    this.productGroups = [];
    this.productOptions = [];
    this.products = [];
    this.couplerStyles = [];
  }

  static search(filter = new SharedDocumentFilter(), page) {
    filter.setPaginationParameters(page);
    return apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new SharedDocument(entity);
  }

  static retire(id) {
    return apiFetch(`${_baseEndPoint}/${id}`, 'DELETE');
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  static downloadCsv(filter = new SharedDocumentFilter(), page)  { 
     filter.setPaginationParameters(page);
     return apiFetch(`${_baseEndPoint}/csv?${filter.toQueryString()}`, 'GET', null, {
      contentType: 'text/csv',
    });
  }
  static download(id, version) {
    return apiFetch(`${_baseEndPoint}/${id}/${version}/download`).then(
      (response) => {
        // (window.location = response.url)

        // The issue with (window.location = response.url) is that the location is changed, so hasUnsavedChanges prompt will show up.
        // window.open(response.url) will help download the file by opening a new tab and close it right after finishing.
        window.open(response.url);
      }
    );
  }

  upload() {
    return apiFetch(`${_baseEndPoint}/${this.id}/revised-document`, 'POST', {
      fileKey: this.fileKey,
    });
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }

  static sharedDocumentsCalculator(
    productId,
    productGroupId,
    productOptionIds
  ) {
    var filter = new SharedDocumentForQuoteFilter({
      productIds: productId ? [productId] : [],
      productGroupIds: productGroupId ? [productGroupId] : [],
      productOptionIds: productOptionIds,
      couplerStyleIds: [],
    });
    return this.sharedDocumentsforQuote(filter);
  }

  static sharedDocumentsforQuote(filter = new SharedDocumentForQuoteFilter()) {
    return apiFetch(`${_baseEndPoint}/quote?${filter.toQueryString()}`);
  }
}
